import { render, staticRenderFns } from "./AtendimentoGuias.vue?vue&type=template&id=6557cdc0&"
import script from "./AtendimentoGuias.vue?vue&type=script&lang=js&"
export * from "./AtendimentoGuias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports